module.exports = __webpack_public_path__ + "img/Ancho_Linda.1c603cb7.png";